// src/pages/NewConversation.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api"; // ✅ centralized axios instance
import { normalizeMediaUrl } from "../lib/media";

import BottomNav from "../components/BottomNav";

export default function NewConversation() {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEligibleUsers();
  }, []);

  const loadEligibleUsers = async () => {
    try {
      const { data } = await api.get("/conversations/eligible-users");
      setUsers(data?.users || []);
    } catch (err) {
      console.error(
        "Failed to load eligible users",
        err?.response?.data || err.message
      );
      alert("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  const startChat = (user) => {
  navigate(`/chat/new`, {
  state: { user }
});
};

  if (loading) {
    return <div style={{ padding: 20 }}>Loading users…</div>;
  }

  return (
  <>
    <div
      className="page has-bottom-nav"
      style={{
        maxWidth: 720,
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 16,
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          fontWeight: 600,
          position: "sticky",
          top: 0,
          background: "#020617",
          zIndex: 5,
          color: "#fff",
        }}
      >
        New Conversation
      </div>

      {users.length === 0 && (
        <div style={{ color: "#9ca3af", marginTop: 24, textAlign: "center" }}>
          No eligible users yet.
          <br />
          Follow someone or get followed to start chatting.
        </div>
      )}

      {users.map((u) => (
        <div
          key={u.id}
          onClick={() => startChat(u)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: 14,
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            cursor: "pointer",
          }}
        >
          <img
            src={
              normalizeMediaUrl(u.profile_pic_url) ||
              "/uploads/default-avatar.png"
            }
            alt=""
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              objectFit: "cover",
              flexShrink: 0,
            }}
          />

          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 600, color: "#fff" }}>
              {u.username || u.user_id}
            </div>
            <div
              style={{
                fontSize: 13,
                color: "#9ca3af",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              @{u.user_id}
            </div>
          </div>
        </div>
      ))}
    </div>

    <BottomNav />
  </>
);
}